import {
  ParticipantAudioTile,
  TrackLoop,
  RoomAudioRenderer,
  TrackToggle,
  useMediaDeviceSelect,
  useTracks,
} from '@livekit/components-react'
import * as React from 'react'
import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Track } from 'livekit-client'
import { type DeviceSettingsStore } from 'entities/DeviceSettings'

export const LiveKitContent = observer(
  ({
    deviceSettingsStore,
    loading,
  }: {
    deviceSettingsStore: DeviceSettingsStore
    loading: boolean
  }) => {
    const isReady = !loading
    const { setActiveMediaDevice: setActiveMediaAudioOutputDevice } = useMediaDeviceSelect({
      kind: 'audiooutput',
    })
    const { setActiveMediaDevice: setActiveMediaAudioInputDevice } = useMediaDeviceSelect({
      kind: 'audioinput',
    })

    useEffect(() => {
      if (deviceSettingsStore.device.audioOutput?.deviceId) {
        setActiveMediaAudioOutputDevice(deviceSettingsStore.device.audioOutput?.deviceId)
      }
    }, [deviceSettingsStore.device.audioOutput?.deviceId])
    useEffect(() => {
      if (deviceSettingsStore.device.audioInput?.deviceId) {
        setActiveMediaAudioInputDevice(deviceSettingsStore.device.audioInput?.deviceId)
      }
    }, [deviceSettingsStore.device.audioInput?.deviceId])

    const audioTracks = useTracks([Track.Source.Microphone])

    return (
      <>
        <RoomAudioRenderer />
        <TrackLoop tracks={audioTracks}>
          <ParticipantAudioTile />
        </TrackLoop>
        {isReady && <TrackToggle source={Track.Source.Microphone} initialState={true} />}
      </>
    )
  }
)
